import { gql } from '@apollo/client';

export const SAVE_FLYER_MUTATION = gql`
  mutation saveFlyer($input: SaveFlyerInput!) {
    saveFlyer(input: $input) {
      flyerId
      isFavorite
    }
  }
`;
